export function formatNumber(
  value: number,
  isTransaction: boolean = false,
  maxDecimalsLarge: number = 2,
  maxDecimalsTiny: number = 10,
) {
  if (value === 0) return '0';

  if (value >= 1) {
    return parseFloat(value.toFixed(maxDecimalsLarge))
      .toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxDecimalsLarge,
      })
      .replace(/,/g, ' ');
  }

  if (isTransaction) {
    if (value >= 0.01) {
      return parseFloat(value.toFixed(2)).toString();
    } else if (value >= 0.0001) {
      return parseFloat(value.toFixed(4)).toString();
    } else {
      return parseFloat(value.toFixed(maxDecimalsTiny)).toString();
    }
  } else {
    if (value >= 0.01) {
      return parseFloat(value.toFixed(2)).toString();
    } else if (value >= 0.0001) {
      return parseFloat(value.toFixed(4)).toString().replace(/0+$/, '');
    } else {
      return parseFloat(value.toFixed(maxDecimalsTiny)).toLocaleString(
        'en-US',
        {
          maximumFractionDigits: maxDecimalsTiny,
        },
      );
    }
  }
}
